export const getGoalPerformanceMetrics = (state: Record<string, any>): Record<string, any> =>
  state.iterableGoals.goalAnalytics.goalPerformance;
